<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Edit Brand</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Brand Name"
                        name="name"
                        type="textarea"
                        placeholder="Brand Name"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.name">
            </base-input>
          </b-col>
          <b-col md="12">
            <base-input label="Brand Description"
                        name="name"
                        type="textarea"
                        placeholder="Brand Description"
                        success-message="Looks good!"
                        v-model="model.description">
            </base-input>
          </b-col>
          
          <b-col md="12">
             <div class="dropzone-icon">
               <loading-panel v-show="loadingLogo"></loading-panel>
                <vue2Dropzone
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-max-files-exceeded="maxFilesExceeded"
                  id="logoDropzone"
                  :options="dropzoneOptions"
                  single
                  ref="logoUpload"
                  v-show="!loadingLogo"
                />
             </div>
          </b-col>
          <b-col md="12">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
        </div>
        <base-button type="primary" native-type="submit">Save Brand</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  //import DropzoneFileUpload from '../../components/Inputs/DropzoneFileUpload.vue';
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import { authHeader } from '../../_helpers';
  import axios from 'axios'
  import LoadingPanel from '../../components/LoadingPanel.vue';
  import vue2Dropzone from 'vue2-dropzone'

  const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/brands/`,
    withCredentials: false,
    headers: authHeader()
  })

  export default {
    name: "EditBrand",
    components: {
        HtmlEditor,
        //DropzoneFileUpload,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions,
        LoadingPanel,
        vue2Dropzone
    },
    data() {
      return {
        model: {
          id: '',
          name: '',
          logo: '',
          isDietary: false,
          isActive: true,
          isDeleted: false,
          isVisible: true,
        },
        logoUpload: [],
        logoId: '',
        loadingLogo: true,
        dropzoneOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          thumbnailWidth: 200,
          thumbnailHeight: 200,
          uploadMultiple: false,
          maxFiles: 1,
          maxFilesize: 256,
          maxThumbnailFilesize: 256,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        }
      }
    },
    methods: {
      firstFormSubmit() {
        const { dispatch } = this.$store;
        if (this.model.name) {
          delete this.model.dropzone;


          if ( this.$refs.logoUpload.dropzone.files[0] && !this.$refs.logoUpload.dropzone.files[0].manuallyAdded  ) {
            this.model.logoUpload = this.$refs.logoUpload.dropzone.files[0];
            delete this.model.logoId;
            delete this.model.logo;
          } else if ( this.$refs.logoUpload.dropzone.files[0] && this.$refs.logoUpload.dropzone.files[0].manuallyAdded ) {
            this.model.logoUpload = null;
          } else {
            this.model.logoUpload = {};
            this.model.logoUpload.delete = { 'uuid': `${this.logoId}` }
          }

           try {
              dispatch("brands/updateBrand", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Brand Updated'});
                  this.$router.push({path: "/brands"});
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: recipe add", error);
          }
        }
      },
      getBrand(id) {
        return apiClient.get(`${id}`);
      },
      loadCurrentImage() {
        if (this.model.logo) {
          var mockFile = { name: this.model.logo.name, size: 50000, type: 'image/jpeg', id: this.model.logo.id};
          this.logoId = this.model.logo.id;
          this.$refs.logoUpload.manuallyAddFile(mockFile, this.model.logo.absoluteUri);
        } else {
          this.loadingLogo = false;
        }
      },
      maxFilesExceeded(file) {
        this.$refs.logoUpload.removeAllFiles()
        this.$refs.logoUpload.addFile(file)
        this.logoUpload = file
      },
      fileAdded(file) {
        this.logoUpload = file
      }
    },
    computed: {
    },
    created() {
      this.model.id = this.$route.params.id;
      this.getBrand(this.model.id)
        .then(response => {
          this.model = response.data;
        })
        .catch(error => {
          console.log(error)
        });
      setTimeout(() => {
          this.loadCurrentImage();
            this.loadingLogo = false;
          }, 3600);
    },
    mounted() {
      
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
